var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "incident" }, [
      _c(
        "div",
        { staticClass: "form-control" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$gettext("Tipo de consulta")))]),
          _c("multiselect", {
            class: {
              error:
                !_vm.message_properties.interaction.valid &&
                _vm.topic_selected == null,
            },
            attrs: {
              options: _vm.incidentInteractions.topics,
              "allow-empty": false,
              searchable: false,
              placeholder: _vm.$gettext("Seleccionar tipo de consulta"),
              "track-by": "id",
              label: "label",
              "show-labels": false,
            },
            on: { select: _vm.interactionSelected },
            model: {
              value: _vm.topic_selected,
              callback: function ($$v) {
                _vm.topic_selected = $$v
              },
              expression: "topic_selected",
            },
          }),
          !_vm.message_properties.interaction.valid &&
          _vm.topic_selected == null
            ? _c("div", { staticClass: "error-message-container" }, [
                _c("i", {
                  staticClass:
                    "error-message error-message-icon icon-message-info",
                }),
                _c("span", { staticClass: "error-message" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$gettext("Por favor, selecciona un tipo de consulta")
                    )
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm.topic_selected && _vm.topic_selected.motive.length > 0
        ? _c(
            "div",
            { staticClass: "form-control" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$gettext("Motivo") + "*"))]),
              _c("multiselect", {
                class: {
                  error:
                    !_vm.message_properties.motive.valid &&
                    _vm.motive_selected == null,
                },
                attrs: {
                  options: _vm.topic_selected.motive,
                  placeholder: _vm.$gettext("Seleccionar motivo"),
                  "allow-empty": false,
                  searchable: false,
                  "track-by": "id",
                  label: "label",
                  "show-labels": false,
                },
                on: { select: _vm.motiveSelected },
                model: {
                  value: _vm.motive_selected,
                  callback: function ($$v) {
                    _vm.motive_selected = $$v
                  },
                  expression: "motive_selected",
                },
              }),
              !_vm.message_properties.motive.valid &&
              _vm.motive_selected == null
                ? _c("div", { staticClass: "error-message-container" }, [
                    _c("i", {
                      staticClass:
                        "error-message error-message-icon icon-message-info",
                    }),
                    _c("span", { staticClass: "error-message" }, [
                      _vm._v(
                        _vm._s(_vm.$gettext("Por favor, selecciona un motivo"))
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }